document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fleece-measurements]').forEach(chart => {
    chart.querySelector('[data-fleece-units]')?.addEventListener('change', event => {
      const unit = event.target.value;
      chart.querySelectorAll('[data-fleece-cm]').forEach(cell => {
        const cm = Number(cell.dataset.fleeceCm);
        cell.textContent = unit === 'cm' ? String(cm) : (cm / 2.54).toFixed(1);
      });
      chart.querySelector('[data-fleece-unit-label]').textContent = unit;
    });
  });
  document.querySelectorAll('.m6060-product [data-product-form]').forEach(form => {
    const text = form.closest('.product-info')?.querySelector('[data-fleece-selected-runtime]');
    const update = () => {
      if (!text) return;
      const value = form.querySelector('[data-bundle-group] input:checked')?.value.replace(/[ ,]/g, '').toLowerCase() || '';
      const runtime = value.includes('20000') ? 'Up to 12 hours of heating. ' : value.includes('10000') ? 'Approx. 5–6 hours of heating. ' : 'No battery included. ';
      text.replaceChildren(document.createTextNode(runtime));
      const link = document.createElement('a');
      link.href = '#FleeceRuntime'; link.textContent = 'Runtime details'; text.append(link);
    };
    form.addEventListener('change', update);
    update();
  });
});
